import axios, { AxiosError, AxiosResponse } from 'axios';
import { appSettings } from '../settings';
import { v7 as uuidv7 } from 'uuid';
import { SessionStore } from '../services/SessionStore';
import { authSettings } from './OidcSettings';
import { setBusy, setNotBusy } from '../store/states/BusySlice';
import { AppStore } from '../store';

export const getAuthToken = () => {
  const sessionKey = `oidc.user:${authSettings.AuthorityUrl}:${authSettings.ClientId}`;
  return SessionStore.get(sessionKey)?.access_token;
};

const AxiosClient = axios.create({
  baseURL: appSettings.DisEndpoint,
  timeout: 60000,
  withCredentials: false,
});

AxiosClient.interceptors.request.use((config) => {
  AppStore.dispatch(setBusy());
  const token = getAuthToken();
  config.headers['X-CORRELATION-ID'] = uuidv7();
  config.headers['Context'] = appSettings.Context;
  config.headers['Content-Type'] = 'application/json; charset=utf-8';
  config.headers['Accept'] = 'application/json';
  config.headers['X-Requested-With'] = 'CfLM-PHC-Admin';
  config.headers['Authorization'] = `Bearer ${token}`;
  return config;
});

AxiosClient.interceptors.response.use(
  (response: AxiosResponse) => {
    AppStore.dispatch(setNotBusy());
    return response;
  },
  (error: AxiosError) => {
    AppStore.dispatch(setNotBusy());
    return Promise.reject(error);
  }
);

export default AxiosClient;
